import { gql } from "@apollo/client";
import { AsyncActionStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils/apolloError";
import { useResettableMutation } from "../useResettableMutation";
import { AddRegisterAssignments, AddRegisterAssignmentsVariables } from "./__generated__/AddRegisterAssignments";

const ADD_REGISTER_ASSIGNMENTS = gql`
  mutation AddRegisterAssignments($orgUserIds: [String!], $permitRegisterId: String!, $permitTypeOrgRoleId: String!) {
    addRegisterAssignments(input: { orgUserIds: $orgUserIds, permitRegisterId: $permitRegisterId, permitTypeOrgRoleId: $permitTypeOrgRoleId }) {
      succeeded
    }
  }
`;

export function useAddRegisterAssignments() {
  const [mutate, { loading, data, error, reset, called }] = useResettableMutation<
    AddRegisterAssignments,
    AddRegisterAssignmentsVariables
  >(ADD_REGISTER_ASSIGNMENTS, {
    errorPolicy: "all",
  });
  return {
    mutate,
    data,
    status: {
      loading,
      reset,
      called,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncActionStatus,
  };
}
